import { SmallDonutCard } from "~/components/SmallDonut";
import { useMetrics } from "~/hooks";
import { Metrics } from "~/lib/arrow";
import { AdvisoriesIcon } from "~/icons";
import { DonutChartCardProps } from "~/pages/space/home-dashboard/components/types";

export function HomeDashboardAdvisoriesDonutChart({
  scope,
}: DonutChartCardProps) {
  const { advisoriesSeverity, isLoading } = useMetrics({
    entityMrn: scope?.mrn || "",
    metricMrns: [Metrics.AdvisoriesSeverity],
  });

  return (
    <SmallDonutCard
      to={`/space/findings/advisories?${scope?.params?.toString()}`}
      loading={isLoading}
      data={advisoriesSeverity}
      data-testid="advisories-donut-chart"
      title="Advisories"
      icon={<AdvisoriesIcon />}
    />
  );
}
